/** Scatti d'ambiente delle collezioni, ritagliati 3:4 in
 *  /assets/collezioni/{slug}.webp (carosello home) e 5:4 in {slug}-54.webp
 *  (griglia /collezioni). Quasi tutti sono foto reali dei servizi VdE (archivio
 *  marketing NAUSICAA/SCENOGRAFICHE NEWSLETTER). Ue Ue e Tinte Uniche non
 *  avevano scatti veri: le loro scene sono GENERATE (Gemini 3 Pro Image) a
 *  partire dai packshot del feed, con i prodotti verificati uno per uno contro
 *  l'originale; lo dichiarano nell'EXIF e in ASSETS A-10. */
const WITH_COVER = new Set([
  'victionary',
  's-p-q-ere',
  'the-market',
  'unico',
  'more-amor',
  'imperial',
  'bigismore',
  'les-petites',
  'baita',
  'radici',
  'le-travisate',
  'ue-ue',
  'tinte-uniche',
  'berlin',
  'the-blue',
  'sicilia',
  'acquerello',
  'venice-lido',
  'venice-lido-modern',
  'confusion-in-colors',
  'marea',
  'botanist',
  'baita-acqua',
  'baita-modern-white',
  'versilia',
  'vintage-xmas',
]);

/** Le due scene generate (A-10): fuori da ogni contesto che parla di «foto vere». */
const GENERATED = new Set(['ue-ue', 'tinte-uniche']);

/** Solo gli scatti reali: la fascia «Dalla materia alla tavola» di /azienda. */
export const REAL_COVER_SLUGS = [...WITH_COVER].filter((s) => !GENERATED.has(s));

export const collectionCover = (slug, suffix = '') =>
  WITH_COVER.has(slug) ? `/assets/collezioni/${slug}${suffix}.webp` : null;
